export default "__VITE_ASSET__EgpVy1QI__"